import { GeoPointDTO } from './geopointDTO';

/**
 * Точка на карте
 */
export class GeoPoint {
  // eslint-disable-next-line no-empty-function
  constructor(readonly lat: number, readonly long: number) {
    if (Number.isNaN(lat) || Number.isNaN(long)) {
      throw new Error('Wrong geoPoint coordinates');
    }
  }

  valueOf() {
    return [this.lat, this.long];
  }

  toString() {
    return `${this.lat},${this.long}`;
  }

  static fromDTO(location: GeoPointDTO) {
    const parts = location.split(',').map(Number);
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    if (parts.length !== 2) {
      throw new Error('Given string is not valid location string');
    }

    return new GeoPoint(parts[0], parts[1]);
  }

  static create(d: { lat: number | string; long?: number | string; lon?: number | string }) {
    return new GeoPoint(Number(d.lat), Number(d.long || d.lon));
  }
}
